import React, { useRef } from "react";
import Link from "next/link";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Image from "next/image";
import ContactUsModalBtn from "./Modal/ContactUs";
import { usePathname } from "next/navigation";
import { useDispatch } from "react-redux";
import {
  setCurrentStep,
  setSelected,
  setSelectedTab,
} from "@/redux/slices/Product";
import {
  INDUSTRY_URLS,
  MARKET_INSIGHTS_ENABLED,
  SOCIAL_LINKS,
} from "@/constastants/Constant";
import { getIntlUrl as getIntlUrlUtil } from "@/utils/Common";

import { PHONE_NUMBER_ONE, PHONE_NUMBER_TWO } from "@/constastants/Constant";
import AbsoluteSkewebar from "./Common/AbsoluteSkewebar";
import { getCDNImageUrl } from "@/utils/Common";

const footerMenu = [
  {
    header: "industries",
    subMenu: [
      {
        name: INDUSTRY_URLS.waterTreatmentAndMining.title,
        url: INDUSTRY_URLS.waterTreatmentAndMining.url,
        isProduct: "Industry",
      },
      {
        name: INDUSTRY_URLS.oilAndGas.title,
        url: INDUSTRY_URLS.oilAndGas.url,
        isProduct: "Industry",
      },
      {
        name: INDUSTRY_URLS.personalCare.title,
        url: INDUSTRY_URLS.personalCare.url,
        isProduct: "Industry",
      },
      {
        name: INDUSTRY_URLS.foodAndNutrition.title,
        url: INDUSTRY_URLS.foodAndNutrition.url,
        isProduct: "Industry",
      },
      {
        name: INDUSTRY_URLS.flavoursAndFragrance.title,
        url: INDUSTRY_URLS.flavoursAndFragrance.url,
        isProduct: "Industry",
      },
      {
        name: INDUSTRY_URLS.homeCareAndIndustrialCleaning.title,
        url: INDUSTRY_URLS.homeCareAndIndustrialCleaning.url,
        isProduct: "Industry",
      },
      {
        name: INDUSTRY_URLS.chemicalIntermediates.title,
        url: INDUSTRY_URLS.chemicalIntermediates.url,
        isProduct: "Industry",
      },
      {
        name: INDUSTRY_URLS.case.title,
        url: INDUSTRY_URLS.case.url,
        isProduct: "Industry",
      },
    ],
  },
  {
    header: "Applications",
    subMenu: [
      {
        name: "Plasticizers",
        url: "/product?category=application&subcategory=plasticizers",
        isProduct: "Application",
      },
      {
        name: "Emulsifier",
        url: "/product?category=application&subcategory=emulsifier",
        isProduct: "Application",
      },
      {
        name: "Mint Chemistry",
        url: "/product?category=application&subcategory=mint-chemistry",
        isProduct: "Application",
      },
      {
        name: "UV Absorber",
        url: "/product?category=application&subcategory=uv-absorber",
        isProduct: "Application",
      },
      {
        name: "Bleaching Agent",
        url: "/product?category=application&subcategory=bleaching-agent",
        isProduct: "Application",
      },
      {
        name: "Antimicrobial",
        url: "/product?category=application&subcategory=antimicrobial",
        isProduct: "Application",
      },
      {
        name: "Chelating agent",
        url: "/product?category=application&subcategory=chelating-agent",
        isProduct: "Application",
      },
      {
        name: "Coagulant",
        url: "/product?category=application&subcategory=coagulant",
        isProduct: "Application",
      },
    ],
  },

  {
    header: "services",
    subMenu: [
      {
        name: "Our Technology",
        url: "/elchemy-tech",
      },
      {
        name: "Custom Manufacturing",
        url: "/quality-custom-chemical-manufacturing",
      },
      {
        name: "Product",
        url: "/product",
      },
      {
        name: "About Us",
        url: "/about-us",
      },
      {
        name: "careers",
        url: "/careers",
      },
      // {
      //   name: "contact us",
      //   // url: "/contact-elchemy",
      // },
      {
        name: "blogs",
        url: "/blogs",
      },
      {
        name: "Events",
        url: "/events",
      },
      ...(MARKET_INSIGHTS_ENABLED
        ? [{ name: "Market Insights", url: "/market-insights" }]
        : []),
    ],
  },
];

const QuickLinks = [
  {
    name: "privacy policy",
    url: "/privacy-policy",
  },
  {
    name: "terms of services",
    url: "/terms-and-conditions",
  },
  {
    name: "Statutory Disclosures",
    url: "/statutory-disclosures",
  },
  {
    name: "Sitemap",
    url: "/sitemap",
  },
  {
    name: "Supplier Code of Conduct",
    url: "https://elchemy-website.s3.ap-south-1.amazonaws.com/Elchemy_Supplier+Code+of+Conduct.pdf",
    target: "_blank",
  },
];

const options = [
  {
    id: "1",
    label: "Chemical Sourcing Inquiry",
  },
  {
    id: "2",
    label: " Custom Manufacturing requirements",
  },
  {
    id: "3",
    label: " Request a Elixir demo",
  },
  {
    id: "4",
    label: "  Interest in joining the team",
  },
  {
    id: "5",
    label: "Interested in other partnership",
  },
];

const CustomFooter = (props) => {
  const { hideCertifications = false } = props;
  const pathname = usePathname();
  const dispatch = useDispatch();
  const contactUsBtnRef = useRef();

  const isIntl = pathname?.endsWith("/intl");
  const getIntlUrl = (url) => getIntlUrlUtil(url, isIntl);

  return (
    <>
      {!hideCertifications ? (
        <div className="spacing_lg">
          <div className="md:px-[3.685rem] px-[2rem]">
            <AbsoluteSkewebar
              text={"Industry-Recognized Credentials of Trust"}
            />
            <div className="grid grid-cols-2 sm:grid-cols-5 gap-4 mt-5 items-center justify-items-center ">
              <p
                dangerouslySetInnerHTML={{
                  __html: `<iframe src="https://profiles.dunsregistered.com/TpTpmsSeal.aspx?Domain=elchemy.com&Directory=" id="TpTpmsSealIFrm" width="160px" height="130px" frameborder="0" scrolling="no" allowtransparency="true"></iframe>`,
                }}
                className="w-full flex justify-center pl-12 md:pl-0"
              />
              <Image
                src={getCDNImageUrl("acd.webp")}
                alt="acd-logo"
                width="105"
                height="120"
                className=" w-[100px] h-[100px] cursor-pointer"
                title="ACD Member"
                onClick={() => {
                  window.open("https://www.acd-chem.com/", "_blank");
                }}
              />
              <Image
                src="https://img.thomascdn.com/badges/shield-tier-v-sm.png?cid=30982710"
                alt="Thomas Supplier"
                srcset="https://img.thomascdn.com/badges/shield-tier-v-sm-2x.png?cid=30982710 2x"
                width="105"
                height="120"
                title="Thomas Verified Supplier"
                className=" w-[90px] h-[90px] cursor-pointer"
                onClick={() => {
                  window.open(
                    "https://www.thomasnet.com/profile/30982710?src=tnbadge",
                    "_blank"
                  );
                }}
              />
              <Image
                src={getCDNImageUrl("wffc.webp")}
                alt="wffc-logo"
                width="120"
                height="120"
                className=" w-[115px] h-[90px]"
                title="WFFC Member"
              />
              <Image
                src={getCDNImageUrl("iso.webp")}
                alt="iso-logo"
                width="105"
                height="120"
                className=" w-[90px] h-[90px]"
                title="ISO 9001:2015 Certified"
              />
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}

      <ContactUsModalBtn
        options={options}
        ref={contactUsBtnRef}
        heading={"Contact Us"}
        subHeading={"Any question or remarks? Just write us a message!"}
        classes={
          "w-[100%] text-[#FFFFFF] h-[48px] bg-red rounded-[4px] font-medium font-mukta text-[1rem]"
        }
      ></ContactUsModalBtn>
      <div
        className={`bg-[#161616] md:pl-20 md:pr-20 md:pt-10 md:pb-5 p-10 ${
          pathname !== "/" ? "" : "scroll-element"
        }`}
      >
        <ToastContainer />
        <div className="flex justify-between md:flex-row flex-col gap-2">
          <div className="flex flex-col items-center sm:items-start w-full mt-5 sm:mt-0 md:w-[50%] mb-4 sm:mb-0">
            <Link href={getIntlUrl("/")} className="" passHref={true}>
              <Image
                src={getCDNImageUrl("whitelogo.svg")}
                alt="logo"
                width="145"
                height="50"
              />
            </Link>
            <p className="md:mt-5 font-mukta text-[1rem] font-normal text-[#FFFFFF] text-center sm:text-left">
              Innovating Global Chemical Trade with Technology-Driven Excellence
            </p>
          </div>
          <div className=" flex flex-col  gap-4 md:w-[30%]">
            <h5 className="text-[#FFFFFF] font-mukta text-[12] font-norml text-center ">
              Have any doubts? Let's connect
            </h5>
            <div className="w-full cursor-pointer">
              <div
                onClick={() => contactUsBtnRef?.current?.setOpen(true)}
                className="w-[100%] flex items-center justify-center text-[#FFFFFF] h-[48px] bg-red rounded-[4px] font-medium font-mukta text-[1rem]"
              >
                Contact Us
              </div>
            </div>

            <div className="md:mt-5 relative"></div>
          </div>
        </div>
        <div className="border border-gray-400 mt-5 opacity-20"></div>

        <div className="flex justify-between md:flex-row flex-col  mt-10">
          {footerMenu?.length > 0 &&
            footerMenu.map((menu, key) => {
              return (
                <>
                  <div key={key}>
                    <h4 className="text-[#646363] text-[16px] mt-8 mb-4 font-mukta uppercase">
                      {menu?.header}
                    </h4>
                    <div>
                      {menu?.subMenu?.length > 0 &&
                        menu?.subMenu.map((sm, index) => {
                          return (
                            <>
                              <li
                                className={`list-none mt-4 font-mukta capitalize text-[#FFFFFF] text-[16px] hover:underline`}
                              >
                                <a
                                  key={index}
                                  href={getIntlUrl(sm?.url) || ""}
                                  onClick={() => {
                                    if (sm?.isProduct) {
                                      dispatch(setSelectedTab(1));
                                      dispatch(
                                        setSelected({
                                          type: sm?.isProduct,
                                          data: sm?.name,
                                          step: 1,
                                        })
                                      );
                                      dispatch(setCurrentStep(2));
                                    }
                                  }}
                                >
                                  {sm?.name}
                                </a>
                              </li>
                            </>
                          );
                        })}
                    </div>
                  </div>
                </>
              );
            })}
          <div className="my-8">
            <h4 className="uppercase text-[#646363] text-[16px] font-mukta font-normal ">
              Contact Us
            </h4>
            <div className="list-none mt-8 ">
              <div className="flex">
                <div className=" flex justify-center items-center">
                  <img
                    src={getCDNImageUrl("footer-email.svg")}
                    alt="phone icon"
                    width={44}
                    height={44}
                  />
                </div>
                <div className="ml-5">
                  <div className="text-[#FFFFFF] text-[14px] font-medium">
                    Email:
                  </div>
                  <div className="text-[#FFFFFF] text-[14px] font-normal hover:underline">
                    <a target="_blank" href="mailto:contact@elchemy.com">
                      info@elchemy.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="list-none mt-8 capitalize flex">
              <div className=" flex justify-center items-center">
                <img
                  src={getCDNImageUrl("footer-phone.svg")}
                  alt="phone icon"
                  width={44}
                  height={44}
                />
              </div>
              <div className="ml-5">
                <div className="text-[#FFFFFF] text-[14px] font-medium">
                  Phone:
                </div>
                <div className="text-[#FFFFFF] text-[14px] font-normal hover:underline">
                  <a target="_blank" href={`tel:${PHONE_NUMBER_ONE.value}`}>
                    {" "}
                    {PHONE_NUMBER_ONE.label}
                  </a>
                </div>

                <div className="text-[#FFFFFF] text-[14px] font-normal hover:underline">
                  <a target="_blank" href={`tel:${PHONE_NUMBER_TWO.value}`}>
                    {" "}
                    {PHONE_NUMBER_TWO.label}
                  </a>
                </div>
              </div>
            </div>
            <div>
              <h4 className="uppercase text-[#646363] text-[16px] mt-8 mb-4 font-mukta">
                Quick Links
              </h4>
              <div>
                {QuickLinks?.map((sm, index) => {
                  return (
                    <>
                      <li
                        className={`list-none mt-4   font-mukta capitalize text-[#FFFFFF] text-[16px] hover:underline`}
                      >
                        <Link key={index} href={getIntlUrl(sm?.url) || ""} target={sm?.target || "_self"} rel={sm?.target === "_blank" ? "noopener noreferrer" : undefined}>
                          {sm?.name}
                        </Link>
                      </li>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="border border-gray-400 opacity-20    mt-5"></div>
        <div className="md:flex justify-between">
          <div className="text-center mt-4 text-[#FFFFFF]">
            Copyright {`@${new Date().getFullYear()}`} Elchemy (Bizinbiz
            Technologies Private Limited) | All Rights Reserved
          </div>
          <div className="flex justify-center mt-4">
            {SOCIAL_LINKS?.map((socialLink, index) => (
              <a
                href={socialLink.url}
                target="_blank"
                key={index}
                title={socialLink.alt}
              >
                <img
                  src={socialLink.logo}
                  alt={socialLink.alt}
                  className="h-[25px] mx-2"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomFooter;
